import { render } from "./branch-view-page.vue?vue&type=template&id=1236488a&scoped=true"
import script from "./branch-view-page.vue?vue&type=script&lang=js"
export * from "./branch-view-page.vue?vue&type=script&lang=js"

import "./branch-view-page.vue?vue&type=style&index=0&id=1236488a&scoped=true&lang=css"

import exportComponent from "/home/mbadr2200/Desktop/RunProf/smouha-club-full-stack/source/frontend-media/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1236488a"]])

export default __exports__